import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * ECG / pulse glyph for the Health overview sidebar item (Figma "pulse", node
 * 16306:68615). The exported artwork is 16×14 and sits 1px in from the top and
 * bottom of the design's 16px icon box; the extra 1-unit offset (and the 18×18
 * viewBox) keeps the ink at 16px when the sidebar renders at `fontSize: 18` —
 * see GridLayoutIcon for the full rationale.
 */
const PulseIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g transform="translate(1 2)">
      <path d="M10 14C9.6 14 9.2 13.7 9.1 13.3L5.8 3.6L3.9 7.4C3.7 7.8 3.4 8 3 8H0V6H2.4L5.1 0.6C5.3 0.2 5.7 0 6.1 0C6.5 0 6.8 0.3 7 0.7L10.2 10.4L12.1 6.6C12.3 6.2 12.6 6 13 6H16V8H13.6L10.9 13.4C10.7 13.8 10.4 14 10 14Z" />
    </g>
  </SvgIcon>
);

export default PulseIcon;
